export const PMA_IMPORT_PERMISSION = 'import.pma';
export const PMA_ACCESS_LEVEL_NAME = 'PMA Standard';

export function userHasPmaImportPermission(staffUser) {
  if (!staffUser) return false;
  const extras = staffUser.extraPermissions || [];
  const fromLevel = staffUser.accessLevel?.permissions || [];
  return extras.includes(PMA_IMPORT_PERMISSION) || fromLevel.includes(PMA_IMPORT_PERMISSION);
}

export function pmaViaAccessLevelOnly(staffUser) {
  if (!staffUser) return false;
  const extras = staffUser.extraPermissions || [];
  const fromLevel = staffUser.accessLevel?.permissions || [];
  return fromLevel.includes(PMA_IMPORT_PERMISSION) && !extras.includes(PMA_IMPORT_PERMISSION);
}

export function nextExtraPermissionsForPma(staffUser, enabled) {
  const set = new Set(staffUser?.extraPermissions || []);
  if (enabled) set.add(PMA_IMPORT_PERMISSION);
  else set.delete(PMA_IMPORT_PERMISSION);
  return [...set];
}
